import type { CreditLedgerEntryOverview } from '@vy/types';
import { VyDialog2 } from '../../../../../../../../components/new-design/feedback/VyDialog2';
import { CreditLedgerOverviewTable } from '../../../../../../OldCustomerOverviewPage/customer-view-page-components/CreditLedger/CreditLedgerOverviewTable';

export type CustomerCreditEntriesDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  creditLedgerEntries: CreditLedgerEntryOverview[];
};

export const CustomerCreditEntriesDialog: React.FC<CustomerCreditEntriesDialogProps> = ({
  isOpen,
  onClose,
  creditLedgerEntries,
}) => (
  <VyDialog2 title="Credit note entries" open={isOpen} maxWidth="md" onClose={onClose} fullWidth>
    <CreditLedgerOverviewTable items={creditLedgerEntries} itemsCount={creditLedgerEntries.length} />
  </VyDialog2>
);
